import { ReactNode, useState } from 'react';

import { SxProps } from '@mui/system';

import Fab from '@mui/material/Fab';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import CloseIcon from '@mui/icons-material/Close';

interface MapPaperProps {
  children: ReactNode;
  sx: SxProps;
  buttonSx: SxProps;
  title: ReactNode;
  icon: ReactNode;
  tooltip: string;
}

function MapPaper({
  children,
  sx,
  buttonSx,
  title,
  icon,
  tooltip,
  ...props
}: MapPaperProps) {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  return (
    <>
      <Fade in={open} appear={false}>
        <Paper
          variant="elevation"
          sx={{
            borderRadius: 4,
            zIndex: 2,
            position: 'absolute',
            p: 3,
            overflow: 'hidden',
            m: 2,
            ...sx,
          }}
          {...props}
        >
          <Stack direction="column" spacing={1}>
            <Stack direction="row" spacing={1} alignItems="center">
              {icon}
              <Typography flexGrow={1} variant="h6">
                {title}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Stack direction="column" spacing={1}>
              {children}
            </Stack>
          </Stack>
        </Paper>
      </Fade>
      <Fade in={!open} timeout={{ exit: 0, enter: 500 }}>
        <Tooltip title={tooltip}>
          <Fab
            size="small"
            sx={{
              zIndex: 1,
              backgroundColor: 'background.paper',
              position: 'absolute',
              ...buttonSx,
            }}
            onClick={handleOpen}
          >
            {icon}
          </Fab>
        </Tooltip>
      </Fade>
    </>
  );
}

export { MapPaper };
